export default "__VITE_ASSET__e3af98e3__"